var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.48 11.0504C21.8135 11.0504 17.2022 11.0504 13.9239 14.7221C11.24 17.723 11.222 21.2182 11.24 22.0655C11.258 21.3947 11.294 17.3876 8.05173 14.1925C4.79141 10.9798 0.684487 11.0151 0 11.0327C1.00872 10.9268 4.66532 10.4502 7.70949 7.39636C10.6456 4.46606 11.1319 1.02384 11.24 0C11.276 1.00619 11.5642 4.25423 14.14 7.13157C17.3463 10.6974 21.6874 10.9798 22.48 11.0327V11.0504Z",
    fill: "#B70569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarImage);
export default __webpack_public_path__ + "static/media/star-image.c57df6a9897a7dc990083d5f85280d4d.svg";
export { ForwardRef as ReactComponent };